/**
 * Cabral Outdoors — Order Tracking widget
 *
 * Expects a container element:
 *   <div id="co-track" data-api="https://YOUR-WORKER.workers.dev/api/track"></div>
 *
 * Mounts automatically on DOMContentLoaded.
 */
(function () {
  "use strict";

  /* --------- Carrier URL routing (fallback when Shopify has no tracking URL) --------- */
  const CARRIERS = [
    { match: /delhivery/i,                 url: (n) => `https://www.delhivery.com/tracking?tracking_id=${encodeURIComponent(n)}` },
    { match: /blue\s*dart|bluedart/i,      url: (n) => `https://www.bluedart.com/tracking?trackingNumber=${encodeURIComponent(n)}` },
    { match: /dtdc/i,                      url: (n) => `https://www.dtdc.in/tracking/tracking_results.asp?strCnno=${encodeURIComponent(n)}&TrkType=CNNO` },
    { match: /india\s*post|speed\s*post|indiapost/i,
                                           url: (n) => `https://www.indiapost.gov.in/_layouts/15/DOP.Portal.Tracking/TrackConsignment.aspx?trackingNo=${encodeURIComponent(n)}` },
    { match: /ekart/i,                     url: (n) => `https://ekartlogistics.com/shipmenttrack/${encodeURIComponent(n)}` },
    { match: /xpressbees/i,                url: (n) => `https://www.xpressbees.com/shipment/tracking?awbNo=${encodeURIComponent(n)}` },
    { match: /shadowfax/i,                 url: (n) => `https://tracker.shadowfax.in/#/tracking/${encodeURIComponent(n)}` },
    { match: /ecom\s*express|ecomexpress/i,url: (n) => `https://ecomexpress.in/tracking/?awb_field=${encodeURIComponent(n)}` },
    { match: /professional/i,              url: (n) => `https://www.tpcindia.com/Tracking2.aspx?cnno=${encodeURIComponent(n)}` },
  ];

  function carrierUrl(company, number) {
    if (!number) return null;
    if (company) {
      for (const c of CARRIERS) if (c.match.test(company)) return c.url(number);
    }
    return `https://www.aftership.com/track/${encodeURIComponent(number)}`;
  }

  /* trackcourier.io deep-link — secondary aggregator option */
  const TRACKCOURIER_SLUGS = [
    { match: /delhivery/i,                 slug: "delhivery-courier" },
    { match: /blue\s*dart|bluedart/i,      slug: "blue-dart-courier" },
    { match: /dtdc/i,                      slug: "dtdc" },
    { match: /india\s*post|speed\s*post|indiapost/i, slug: "speed-post" },
    { match: /ekart/i,                     slug: "ekart-logistics" },
    { match: /xpressbees/i,                slug: "xpressbees" },
    { match: /shadowfax/i,                 slug: "shadowfax" },
    { match: /ecom\s*express|ecomexpress/i,slug: "ecom-express" },
    { match: /professional/i,              slug: "professional-courier" },
    { match: /trackon/i,                   slug: "trackon-courier" },
    { match: /aramex/i,                    slug: "aramex" },
    { match: /dhl/i,                       slug: "dhl" },
    { match: /fedex/i,                     slug: "fedex" },
  ];
  function trackCourierIoUrl(company, number) {
    if (!number) return null;
    let slug = "";
    if (company) {
      for (const s of TRACKCOURIER_SLUGS) if (s.match.test(company)) { slug = s.slug; break; }
    }
    if (!slug) return null;
    return `https://trackcourier.io/track-and-trace/${slug}/${encodeURIComponent(number)}`;
  }

  /* Pretty-print financial/fulfillment status into a chip { label, modifier } */
  function financialChip(value) {
    const v = String(value || "").toLowerCase();
    if (!v) return null;
    let mod = "pending";
    if (v.includes("paid") && !v.includes("partially")) mod = "paid";
    else if (v.includes("refund")) mod = "refunded";
    else if (v.includes("partial")) mod = "partial";
    return { modifier: mod, text: v.replace(/_/g, " ") };
  }
  function fulfillmentChip(value, cancelled) {
    if (cancelled) return { modifier: "cancelled", text: "cancelled" };
    const v = String(value || "").toLowerCase();
    if (!v) return null;
    let mod = "unfulfilled";
    if (v === "fulfilled") mod = "fulfilled";
    else if (v.includes("partial")) mod = "partial";
    return { modifier: mod, text: v.replace(/_/g, " ") };
  }

  /* --------- Inline icons --------- */
  const ICON = {
    check: '<svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M16.7 5.3a1 1 0 010 1.4l-8 8a1 1 0 01-1.4 0l-4-4a1 1 0 011.4-1.4L8 12.6l7.3-7.3a1 1 0 011.4 0z" clip-rule="evenodd"/></svg>',
    cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 3h2l1.6 12.2a2 2 0 002 1.8H18a2 2 0 002-1.7L21.6 8H6"/><circle cx="9" cy="20" r="1.4"/><circle cx="17" cy="20" r="1.4"/></svg>',
    card: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="6" width="18" height="13" rx="2"/><path d="M3 10h18"/></svg>',
    box: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7l9-4 9 4-9 4-9-4z"/><path d="M3 7v10l9 4 9-4V7"/><path d="M12 11v10"/></svg>',
    home: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 11l9-7 9 7"/><path d="M5 10v10h14V10"/></svg>',
    info: '<svg viewBox="0 0 20 20" fill="currentColor" width="20" height="20" aria-hidden="true"><path fill-rule="evenodd" d="M10 2a8 8 0 100 16 8 8 0 000-16zm.8 5a1 1 0 10-1.6 0 1 1 0 001.6 0zM9 9a1 1 0 100 2v3a1 1 0 102 0v-4a1 1 0 00-1-1H9z" clip-rule="evenodd"/></svg>',
    warn: '<svg viewBox="0 0 20 20" fill="currentColor" width="20" height="20" aria-hidden="true"><path d="M10 1.5a1 1 0 01.9.55l8 15a1 1 0 01-.9 1.45H2a1 1 0 01-.9-1.45l8-15A1 1 0 0110 1.5zm0 5.5a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1zm0 9.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2z"/></svg>',
    arrowOut: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 17L17 7"/><path d="M8 7h9v9"/></svg>',
  };

  /* --------- DOM helpers --------- */
  function el(tag, attrs = {}, children = []) {
    const node = document.createElement(tag);
    for (const [k, v] of Object.entries(attrs)) {
      if (v === null || v === undefined || v === false) continue;
      if (k === "class") node.className = v;
      else if (k === "html") node.innerHTML = v;
      else if (k.startsWith("on") && typeof v === "function") node.addEventListener(k.slice(2), v);
      else node.setAttribute(k, v);
    }
    for (const c of [].concat(children)) {
      if (c == null) continue;
      node.appendChild(typeof c === "string" ? document.createTextNode(c) : c);
    }
    return node;
  }

  function fmtDate(iso) {
    if (!iso) return "";
    try {
      const d = new Date(iso);
      return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
    } catch { return iso; }
  }

  /* --------- Status inference ---------
   *   0 Placed    — always done
   *   1 Paid      — financialStatus contains "paid"
   *   2 Shipped   — at least one fulfillment exists
   *   3 Delivered — order's displayFulfillmentStatus is FULFILLED. Shopify
   *                 itself doesn't know courier delivery status; we defer
   *                 that to the courier site via the "Track on courier" CTA.
   */
  function deriveStatus(order) {
    const financial = String(order.financialStatus || "").toLowerCase();
    const fulfillment = String(order.fulfillmentStatus || "").toLowerCase();
    const isCancelled = !!order.cancelledAt;
    const hasFulfillments = (order.fulfillments || []).length > 0;
    const anyTracking = (order.fulfillments || []).some(
      (f) => (f.tracking || []).some((t) => t.number)
    );
    const isPaid = financial.includes("paid") && !financial.includes("partially");
    const isFulfilled = fulfillment === "fulfilled";

    if (isCancelled) return { activeIndex: -1, cancelled: true };

    // Progress caps at "Shipped" (index 2) because Shopify's FULFILLED status
    // only means the merchant created a fulfillment — not that the courier
    // actually delivered the package. "Delivered" stays pending (greyed out)
    // until we integrate a real courier-delivery API.
    let activeIndex = 0;
    if (isPaid) activeIndex = 1;
    if (hasFulfillments || anyTracking) activeIndex = 2;

    return { activeIndex, cancelled: false, hasFulfillments, anyTracking, isPaid, isFulfilled };
  }

  /* --------- Render --------- */
  function renderForm(root, onSubmit) {
    root.innerHTML = "";
    const form = el("form", { class: "co-track__form", novalidate: "true" });

    const orderField = el("div", { class: "co-track__field" }, [
      el("label", { for: "co-track-order" }, "Order number"),
      el("input", {
        id: "co-track-order", name: "order_number", type: "text",
        required: "true", autocomplete: "off", placeholder: "e.g. CO12345",
      }),
    ]);

    const contactField = el("div", { class: "co-track__field" }, [
      el("label", { for: "co-track-contact" }, "Phone Number or Email"),
      el("input", {
        id: "co-track-contact", name: "contact", type: "text",
        autocomplete: "email", placeholder: "you@example.com or +91 98xxxxxxxx",
      }),
    ]);

    const submitRow = el("div",
      { class: "co-track__row--full", style: "display:flex;flex-wrap:wrap;gap:14px;align-items:center;" }, [
      el("button", { type: "submit", class: "co-track__btn" }, "Track my order"),
      el("div", { class: "co-track__hint" }, "Use the email or phone you entered at checkout."),
    ]);

    form.append(orderField, contactField, submitRow);

    form.addEventListener("submit", (ev) => {
      ev.preventDefault();
      const orderNum = form.elements.order_number.value.trim();
      const contactRaw = form.elements.contact.value.trim();
      if (!orderNum) return setError(root, "Please enter your order number.");
      if (!contactRaw) return setError(root, "Please enter the email or phone you used at checkout.");

      // Auto-detect whether the contact value is an email or a phone number.
      // Anything containing "@" is treated as email; otherwise it's a phone.
      const isEmail = /@/.test(contactRaw);
      const data = {
        order_number: orderNum,
        email: isEmail ? contactRaw : "",
        phone: isEmail ? "" : contactRaw,
      };
      onSubmit(data, form);
    });

    // WhatsApp CTA — matches the card style on /pages/contacts
    const whatsapp = el("a", {
      class: "co-track__whatsapp",
      href: "https://wa.me/917483148696?text=Hi+Cabral+Outdoors%2C+I+have+a+question+about+my+order.",
      target: "_blank",
      rel: "noopener noreferrer",
      "aria-label": "Chat with us on WhatsApp",
    });
    whatsapp.innerHTML =
      '<span class="co-track__whatsapp-ico">' +
      '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">' +
      '<path fill="currentColor" d="M20.52 3.48A11.91 11.91 0 0 0 12.02 0 12.03 12.03 0 0 0 0 12.05c0 2.12.56 4.1 1.54 5.82L0 24l6.3-1.65a12 12 0 0 0 5.73 1.46C18.66 23.81 24 18.41 24 12.05c0-3.22-1.25-6.25-3.48-8.57ZM12.03 22a9.94 9.94 0 0 1-5.05-1.38l-.36-.21-3.74.98 1-3.65-.24-.38A9.93 9.93 0 1 1 22 12.04c0 5.46-4.5 9.96-9.97 9.96Zm5.72-7.47c-.31-.16-1.84-.9-2.12-1-.28-.1-.49-.16-.7.16-.2.31-.8 1-.98 1.2-.18.2-.36.23-.67.08-.31-.16-1.3-.48-2.48-1.54-.92-.82-1.54-1.84-1.72-2.15-.18-.31-.02-.48.13-.64.13-.13.31-.36.46-.54.15-.18.2-.31.31-.51.1-.2.05-.38-.03-.54-.08-.16-.7-1.68-.96-2.3-.25-.6-.5-.52-.7-.53l-.6-.01c-.2 0-.54.08-.82.38-.28.31-1.07 1.05-1.07 2.56s1.1 2.97 1.26 3.17c.16.2 2.17 3.32 5.25 4.66.73.32 1.3.51 1.74.65.73.23 1.4.2 1.93.12.59-.09 1.84-.75 2.1-1.48.26-.73.26-1.35.18-1.48-.08-.13-.28-.2-.59-.36Z"/>' +
      '</svg>' +
      '</span>' +
      '<span class="co-track__whatsapp-text">' +
        '<strong>WhatsApp</strong>' +
        '<span>+91 7483148696</span>' +
      '</span>';

    root.append(
      whatsapp,
      el("h1", { class: "co-track__title" }, "Track your order"),
      el("p", { class: "co-track__sub" },
        "Enter your order number and the email or phone you used at checkout."),
      form,
      el("div", { class: "co-track__result", id: "co-track-result" })
    );
  }

  function setError(root, msg) {
    clearResult(root);
    const result = root.querySelector("#co-track-result");
    result.appendChild(el("div", { class: "co-track__error", role: "alert" }, msg));
  }

  function clearResult(root) {
    const result = root.querySelector("#co-track-result");
    if (result) result.innerHTML = "";
  }

  function setLoading(form, loading) {
    const btn = form.querySelector("button[type=submit]");
    if (!btn) return;
    btn.disabled = loading;
    btn.textContent = loading ? "Looking up\u2026" : "Track my order";
  }

  /* Step + progress tracker */
  function stepNode({ label, sub, iconHtml, state }) {
    const dot = el("div", { class: "co-track__step-dot" });
    dot.innerHTML = state === "done" ? ICON.check : iconHtml;
    return el("div", { class: `co-track__step co-track__step--${state}`, role: "listitem" }, [
      dot,
      el("div", { class: "co-track__step-label" }, label),
      sub ? el("div", { class: "co-track__step-sub" }, sub) : null,
    ]);
  }

  function progressTracker(order, status) {
    const shippedDate = (order.fulfillments || [])
      .map((f) => f.createdAt).filter(Boolean).sort()[0];

    const steps = [
      { label: "Order Placed", sub: fmtDate(order.createdAt),           icon: ICON.cart },
      { label: "Payment",      sub: status.isPaid ? "Received" : "Pending", icon: ICON.card },
      { label: "Shipped",      sub: shippedDate ? fmtDate(shippedDate) : "Pending", icon: ICON.box },
      { label: "Delivered",    sub: status.isFulfilled ? "Completed" : "In transit", icon: ICON.home },
    ];

    const wrap = el("div", { class: "co-track__progress", role: "list" });
    steps.forEach((s, i) => {
      let state = "pending";
      if (i < status.activeIndex) state = "done";
      else if (i === status.activeIndex) state = "current";
      wrap.appendChild(stepNode({ label: s.label, sub: s.sub, iconHtml: s.icon, state }));
    });
    return wrap;
  }

  function statusStrip(order, status) {
    if (status.cancelled) {
      return el("div", { class: "co-track__status-strip co-track__status-strip--danger" }, [
        el("span", { html: ICON.warn }),
        el("div", {}, [
          el("span", { class: "co-track__status-strip-title" }, "This order has been cancelled"),
          `Cancelled on ${fmtDate(order.cancelledAt)}. Please contact support if you believe this is a mistake.`,
        ]),
      ]);
    }
    if (status.hasFulfillments) {
      return el("div", { class: "co-track__status-strip co-track__status-strip--info" }, [
        el("span", { html: ICON.check }),
        el("div", {}, [
          el("span", { class: "co-track__status-strip-title" }, "Your order is Shipped"),
          "Use the courier link below for its current location and expected delivery.",
        ]),
      ]);
    }
    // Not yet shipped — covers both "paid, preparing" and "placed, unpaid".
    return el("div", { class: "co-track__status-strip co-track__status-strip--warn" }, [
      el("span", { html: ICON.info }),
      el("div", {}, [
        el("span", { class: "co-track__status-strip-title" }, "Your order is Not Shipped"),
        status.isPaid
          ? "Payment confirmed. You\u2019ll see tracking here as soon as your order ships."
          : "We\u2019ll confirm once payment is received and your order is ready to ship.",
      ]),
    ]);
  }

  function fulfillmentsSection(order) {
    const wrap = el("div");
    const fulfillments = order.fulfillments || [];
    if (fulfillments.length === 0) {
      wrap.appendChild(el("div", { class: "co-track__empty" },
        "Your order hasn\u2019t shipped yet. You\u2019ll see tracking here as soon as it\u2019s dispatched."));
      return wrap;
    }
    fulfillments.forEach((f, i) => {
      const box = el("div", { class: "co-track__fulfillment" });
      box.appendChild(el("div", { class: "co-track__fulfillment-head" }, [
        el("span", {}, fulfillments.length > 1 ? `Shipment ${i + 1}` : "Shipment"),
        el("span", { class: "co-track__fulfillment-meta" },
          f.createdAt ? `Shipped ${fmtDate(f.createdAt)}` : ""),
      ]));

      const tracking = f.tracking || [];
      if (tracking.length === 0) {
        box.appendChild(el("div", { class: "co-track__empty" },
          "Tracking number will appear here once the courier updates it."));
      } else {
        tracking.forEach((t) => {
          const url = t.url || carrierUrl(t.company, t.number);
          const row = el("div", { class: "co-track__tracking-row" });
          row.appendChild(el("span", { class: "co-track__tracking-carrier" }, t.company || "Courier"));
          if (t.number) {
            row.appendChild(el("span", { class: "co-track__tracking-number" },
              el("code", {}, t.number)));
          }
          if (url) {
            const btn = el("a", {
              class: "co-track__track-btn",
              href: url, target: "_blank", rel: "noopener noreferrer",
            });
            btn.appendChild(document.createTextNode("Track on courier"));
            const icon = el("span", { html: ICON.arrowOut });
            icon.style.display = "inline-flex";
            btn.appendChild(icon);
            row.appendChild(btn);
          }

          // Secondary link via trackcourier.io aggregator, when we can resolve a slug
          const altUrl = trackCourierIoUrl(t.company, t.number);
          if (altUrl) {
            const altBtn = el("a", {
              class: "co-track__alt-btn",
              href: altUrl, target: "_blank", rel: "noopener noreferrer",
              title: "Alternate tracker (trackcourier.io)",
            });
            altBtn.appendChild(document.createTextNode("Alt tracker"));
            const altIcon = el("span", { html: ICON.arrowOut });
            altIcon.style.display = "inline-flex";
            altBtn.appendChild(altIcon);
            row.appendChild(altBtn);
          }
          box.appendChild(row);
        });
      }
      wrap.appendChild(box);
    });
    return wrap;
  }

  function shippingNote(order) {
    if (!order.shippingTo) return null;
    const s = order.shippingTo;
    const line = [s.name, s.city, s.province, s.zip].filter(Boolean).join(", ");
    return el("p", { class: "co-track__shipping-note" }, [
      el("strong", {}, "Shipping to: "),
      line,
    ]);
  }

  function itemsList(order) {
    const items = order.lineItems || [];
    if (items.length === 0) {
      return el("div", { class: "co-track__empty" }, "No items on this order.");
    }
    const ul = el("ul", { class: "co-track__items" });
    items.forEach((it) => {
      const thumb = it.image
        ? el("img", { src: it.image, alt: it.title, loading: "lazy" })
        : el("div", { class: "co-track__items-thumb" });
      const info = el("div", { style: "flex:1;min-width:0;" }, [
        el("div", { class: "co-track__item-title" }, it.title),
        el("div", { class: "co-track__item-sub" }, it.variantTitle ? it.variantTitle : ""),
      ]);
      const qty = el("div", { class: "co-track__item-qty" }, `Qty ${it.quantity}`);
      ul.appendChild(el("li", {}, [thumb, info, qty]));
    });
    return ul;
  }

  function chipNode(prefix, chip) {
    if (!chip) return null;
    return el("span", { class: `co-track__chip co-track__chip--${chip.modifier}` }, [
      el("span", { class: "co-track__chip-label" }, prefix),
      el("span", { class: "co-track__chip-value" }, chip.text),
    ]);
  }

  function shippedViaSummary(order) {
    const firstFul = (order.fulfillments || [])[0];
    const firstTracking = firstFul && (firstFul.tracking || [])[0];
    const carrier = firstTracking && firstTracking.company;
    const awb = firstTracking && firstTracking.number;
    const shippedDate = firstFul && firstFul.createdAt;

    if (!carrier && !awb && !shippedDate) return null;

    const row = el("div", { class: "co-track__summary" });
    row.appendChild(el("div", { class: "co-track__summary-item" }, [
      el("div", { class: "co-track__summary-label" }, "Shipped via"),
      el("div", { class: "co-track__summary-value" }, carrier || "\u2014"),
    ]));
    row.appendChild(el("div", { class: "co-track__summary-item" }, [
      el("div", { class: "co-track__summary-label" }, "AWB / Tracking #"),
      el("div", { class: "co-track__summary-value" }, awb || "\u2014"),
    ]));
    row.appendChild(el("div", { class: "co-track__summary-item" }, [
      el("div", { class: "co-track__summary-label" }, "Shipped on"),
      el("div", { class: "co-track__summary-value" }, shippedDate ? fmtDate(shippedDate) : "\u2014"),
    ]));
    return row;
  }

  function renderOrder(root, order) {
    clearResult(root);
    const result = root.querySelector("#co-track-result");
    const status = deriveStatus(order);

    const card = el("div", { class: "co-track__card" });

    // --- Card head with labeled chips ---
    const head = el("div", { class: "co-track__card-head" });
    head.appendChild(el("div", { class: "co-track__head-left" }, [
      el("h2", { class: "co-track__order-name" }, `Order ${order.name}`),
      el("div", { class: "co-track__meta" }, `Placed ${fmtDate(order.createdAt)}`),
    ]));
    const chips = el("div", { class: "co-track__head-right" });
    const payChip = chipNode("Payment", financialChip(order.financialStatus));
    const shipChip = chipNode("Shipping", fulfillmentChip(order.fulfillmentStatus, !!order.cancelledAt));
    if (payChip) chips.appendChild(payChip);
    if (shipChip) chips.appendChild(shipChip);
    head.appendChild(chips);
    card.appendChild(head);

    const body = el("div", { class: "co-track__card-body" });

    body.appendChild(progressTracker(order, status));
    body.appendChild(statusStrip(order, status));

    // Shipped-via summary (only when we have something to show)
    const summary = shippedViaSummary(order);
    if (summary) body.appendChild(summary);

    body.appendChild(el("div", { class: "co-track__section-title" }, "Shipment"));
    body.appendChild(fulfillmentsSection(order));

    const note = shippingNote(order);
    if (note) body.appendChild(note);

    body.appendChild(el("div", { class: "co-track__section-title" }, "Items in this order"));
    body.appendChild(itemsList(order));

    card.appendChild(body);
    result.appendChild(card);

    try { card.scrollIntoView({ behavior: "smooth", block: "start" }); } catch {}
  }

  /* --------- Cloudflare Turnstile (invisible bot challenge) --------- */
  // The Turnstile API script is loaded from the Liquid template with an
  // onload=coTurnstileOnload callback. We keep a single widget rendered
  // invisibly in the page and call execute() each time the form submits.
  let _turnstileWidgetId = null;
  let _turnstileSiteKey = null;

  // Global onload handler — invoked once by the Turnstile script when ready.
  window.coTurnstileOnload = function () {
    if (!_turnstileSiteKey || !window.turnstile) return;
    if (_turnstileWidgetId !== null) return;
    let host = document.getElementById("co-turnstile-host");
    if (!host) {
      host = document.createElement("div");
      host.id = "co-turnstile-host";
      host.style.cssText = "position:absolute;width:0;height:0;overflow:hidden;";
      document.body.appendChild(host);
    }
    try {
      _turnstileWidgetId = window.turnstile.render(host, {
        sitekey: _turnstileSiteKey,
        size: "invisible",
      });
    } catch (_) {}
  };

  async function getTurnstileToken() {
    if (!_turnstileSiteKey) return ""; // Turnstile not configured on this page
    if (!window.turnstile) {
      // Script didn't load — block bots loudly, but let admins debug
      throw new Error("Verification service unavailable. Please reload the page.");
    }
    if (_turnstileWidgetId === null) window.coTurnstileOnload();
    if (_turnstileWidgetId === null) {
      throw new Error("Verification widget failed to load.");
    }
    return new Promise((resolve, reject) => {
      let settled = false;
      const timer = setTimeout(() => {
        if (!settled) { settled = true; reject(new Error("Verification timed out. Please try again.")); }
      }, 20000);
      try {
        window.turnstile.reset(_turnstileWidgetId);
        window.turnstile.execute(_turnstileWidgetId, {
          callback: (token) => {
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            resolve(token);
          },
          "error-callback": () => {
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            reject(new Error("Verification failed. Please refresh and try again."));
          },
        });
      } catch (err) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        reject(err);
      }
    });
  }

  /* --------- Bootstrap --------- */
  async function lookup(api, data) {
    // Obtain Turnstile token (if site key configured) before hitting the API.
    if (_turnstileSiteKey) {
      try {
        data.turnstile_token = await getTurnstileToken();
      } catch (err) {
        throw err;
      }
    }
    const res = await fetch(api, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    const body = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(body.error || `Request failed (${res.status})`);
    return body.order;
  }

  function init() {
    const root = document.getElementById("co-track");
    if (!root) return;
    if (!root.classList.contains("co-track")) root.classList.add("co-track");

    // Unwrap any .co-track-center container inserted by older versions.
    if (root.parentElement && root.parentElement.classList.contains("co-track-center")) {
      const oldWrap = root.parentElement;
      oldWrap.parentNode.insertBefore(root, oldWrap);
      oldWrap.remove();
    }

    // Position the widget in the viewport.
    //  - Touch devices (phones/tablets): left-aligned with 16px gutter
    //  - Mouse devices (desktop): centred horizontally
    // Touch detection via matchMedia('(pointer: coarse)') is reliable across
    // devices even when the phone reports an unusual viewport width.
    const isTouchDevice = (() => {
      try {
        return window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
      } catch (_) { return false; }
    })();

    const alignToViewport = () => {
      try {
        root.style.transform = "";
        const rect = root.getBoundingClientRect();
        if (rect.width === 0) return;
        let delta;
        if (isTouchDevice) {
          // Mobile/tablet: left edge at 16px from viewport left
          delta = 16 - rect.left;
        } else {
          // Desktop: centre in viewport
          const currentCenter = rect.left + rect.width / 2;
          const viewportCenter = window.innerWidth / 2;
          delta = viewportCenter - currentCenter;
        }
        if (Math.abs(delta) > 0.5) root.style.transform = `translateX(${delta}px)`;
      } catch (_) {}
    };
    alignToViewport();
    setTimeout(alignToViewport, 50);
    setTimeout(alignToViewport, 250);
    window.addEventListener("resize", alignToViewport);

    const api = root.getAttribute("data-api");
    if (!api) {
      root.textContent = "Tracking is misconfigured: missing data-api URL.";
      return;
    }

    // Turnstile site key (optional). Only a non-placeholder value enables it.
    const siteKey = root.getAttribute("data-turnstile-sitekey") || "";
    if (siteKey && !/PASTE_YOUR/.test(siteKey)) {
      _turnstileSiteKey = siteKey;
      // If the Turnstile script already loaded before init (cached),
      // render the widget now; otherwise the onload callback will fire.
      if (window.turnstile) window.coTurnstileOnload();
    }

    renderForm(root, async (data, form) => {
      clearResult(root);
      setLoading(form, true);
      try {
        const order = await lookup(api, data);
        renderOrder(root, order);
      } catch (err) {
        setError(root, err.message || "Something went wrong. Please try again.");
      } finally {
        setLoading(form, false);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
